// Squared distance from point (px, py) to line segment (ax, ay)-(bx, by) —
// squared is enough since we only compare which segment is SMALLEST, no
// Math.sqrt needed per segment.
function distanceToSegmentSquared(px, py, ax, ay, bx, by) {
    const dx = bx - ax;
    const dy = by - ay;
    const lengthSquared = dx * dx + dy * dy;
    if (lengthSquared === 0) {
        return (px - ax) ** 2 + (py - ay) ** 2;
    }
    let t = ((px - ax) * dx + (py - ay) * dy) / lengthSquared;
    t = Math.max(0, Math.min(1, t));
    const projX = ax + t * dx;
    const projY = ay + t * dy;
    return (px - projX) ** 2 + (py - projY) ** 2;
}

class ConnectorSegmentFinder {
    /**
     * Segment index i (between points[i] and points[i+1]) closest to (px, py) —
     * the correct insertion position in UmlConnector.points[] for a double-click on the line.
     * @param {{x: number, y: number}[]} points
     * @param {number} px
     * @param {number} py
     * @returns {number}
     */
    static nearestSegmentIndex(points, px, py) {
        let bestIndex = 0;
        let bestDistance = Infinity;
        for (let i = 0; i < points.length - 1; i += 1) {
            const a = points[i];
            const b = points[i + 1];
            const distance = distanceToSegmentSquared(px, py, a.x, a.y, b.x, b.y);
            if (distance < bestDistance) {
                bestDistance = distance;
                bestIndex = i;
            }
        }
        return bestIndex;
    }
}

export default ConnectorSegmentFinder;
